import React from "react";
import { Flex, Image } from "@chakra-ui/react";
import { FormValues } from "../../duck";
import { IntegrationForm } from "./components";

interface IntegrationCardProps {
  logo: string;
  serviceName: string;
  onSubmit(formValues: FormValues): Promise<any>;
  defaultValues: FormValues;
  inputName: string;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  logo,
  serviceName,
  onSubmit,
  defaultValues,
  inputName
}) => {
  return (
    <Flex
      h="207px"
      w="232px"
      border="1px solid"
      borderColor="dark.500"
      borderRadius="xl"
      direction="column"
      justify="center"
      align="center"
      rowGap={6}
    >
      <Image src={logo} alt="Logo" />
      <IntegrationForm
        serviceName={serviceName}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        inputName={inputName}
      />
    </Flex>
  );
};

export default IntegrationCard;
